<script setup lang="ts"></script>

<template>
  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.73425 18.1454C4.54384 16.5801 3.933 14.6505 4.0058 12.6853C4.07861 10.7201 4.83056 8.84098 6.13353 7.36807C7.4365 5.89516 9.20987 4.9196 11.1515 4.60762C13.0931 4.29564 15.0828 4.66654 16.7816 5.65713C18.4804 6.64771 19.7832 8.19669 20.468 10.0401C21.1528 11.8836 21.1772 13.9074 20.537 15.7668C19.8969 17.6263 18.6319 19.2062 16.9574 20.2375C15.283 21.2687 13.3028 21.6875 11.3542 21.4224"
      stroke="currentColor"
    />
    <path d="M2 17.4425L6.08564 18.586L7.22913 14.5004" stroke="currentColor" />
    <path d="M12.5 8.50018L12.5 13.0002" stroke="currentColor" />
    <path d="M16.5 16.5002L12.5 13.0002" stroke="currentColor" />
    <circle cx="12.5" cy="13.0002" r="0.5" fill="currentColor" />
  </svg>
</template>

<style scoped lang="postcss"></style>
